import React from "react"
import { getTime } from "../../../../services/CommonFunction"
import "./StopWatch.scss"

const TimeUI = ({ text, time, ...props }) => {
  const themeColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--theme-color")
  return (
    <div className="timeUI">
      <span className={`number ${themeColor === "light" ? "light" : "dark"}`}>
        {time}
      </span>
      {/* {text} */}
    </div>
  )
}
export default function StopWatch({ duration, ...props }) {
  const { /* hour, */ minutes, second } = getTime(duration)
  return (
    <div className="WRStopWatch">
      <span className="title">Starts in :</span>
      <div className="time">
        <TimeUI text="Min" time={minutes} />
        <TimeUI text="Sec" time={second} />
      </div>
    </div>
  )
}
